export const ecoLeatherPhotos = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/aG7yiaTHTrC1hXgfT653Xb/IMG_1548.jpg',
    alt: 'Чорні штани з еко шкіри та шкіряна куртка',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wsDBgjipyR2GXJYVQxAMcg/IMG_1557.jpg',
    alt: 'Шоколадні широкі штани з еко шкіри з оливковим светром',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9mbavUuNmX3V12QSQVTHMJ/IMG_1553.jpg',
    alt: 'Чорні штани з еко шкіри на осінній прогулянці',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1SJU7SN6r8pw7KA7sPjXxa/IMG_1558.jpg',
    alt: 'Деталь посадки шоколадних штанів з еко шкіри',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wcTnx3bG1yiB1cX6Ebf7Qq/IMG_1371.jpg',
    alt: 'Чорна спідниця-шорти з еко шкіри із запахом',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kg8PcSXB5c85jB7UqW6EaU/IMG_1368.jpg',
    alt: 'Спідниця-шорти з еко шкіри — вигляд збоку із шортами під запахом',
  },
]
